import React from 'react'

const Bar = ({ children, backgroundColor }) => {
  const styles = {
    root: {
      border: `solid 1px ${backgroundColor}`,
      backgroundColor,
      borderRadius: 3,
      padding: 5
    }
  }

  return (
    <div className="bar" style={styles.root}>
      {children}
    </div>
  )
}

export default Bar
